import { createActions } from 'redux-actions';

const actions = createActions({
  CONTENTFUL_ENTRIES_FAILED: (data) => data,
  CONTENTFUL_ENTRIES_LOADED: (data) => data,
  GET_CONTENTFUL_ENTRIES: (data) => data,
});

export const {
  contentfulEntriesFailed,
  contentfulEntriesLoaded,
  getContentfulEntries,
} = actions;
